import { render, staticRenderFns } from "./CompanyImage.vue?vue&type=template&id=971e2838"
import script from "./CompanyImage.vue?vue&type=script&lang=js"
export * from "./CompanyImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports